module.exports = __webpack_public_path__ + "img/achievement_28.30adc6d1.png";